export const setRemainingFeatureBalance = data => ({
    type: 'REMAINING_FEATURE_BALANCE',
    payload: data
  });

export const setIsExpandedView = data => ({
  type: 'IS_EXPANDED_VIEW',
  payload: data
});